import { BillingFrequency, BillingMethod, ContractType } from '../types/agreement'
import { getValidBillingFrequencies } from '../utils/consistencyRules'

export function normalizeBillingMethod(
  billingFrequency: BillingFrequency | string | '',
  current: string | BillingMethod | ''
): BillingMethod | '' {
  if (billingFrequency === 'progress') return 'progress'
  if (current === 'progress') return ''
  return (current as BillingMethod) || ''
}

export function normalizeBillingFrequency(
  contractType: ContractType | '',
  current: string | BillingFrequency | ''
): BillingFrequency | '' {
  if (!contractType) return (current as BillingFrequency) || ''
  const valid = getValidBillingFrequencies(contractType)
  if (current && valid.includes(current as BillingFrequency)) {
    return current as BillingFrequency
  }
  if (contractType === 'one_time') return 'one_time'
  if (contractType === 'as_needed') return 'after_each_service'
  return 'monthly'
}

export function defaultBillingFrequencyForSave(
  contractType: ContractType | '',
  current: string | BillingFrequency | ''
): BillingFrequency {
  if (contractType === 'one_time') {
    return (current as BillingFrequency) || 'one_time'
  }
  if (contractType === 'as_needed') {
    return (current as BillingFrequency) || 'after_each_service'
  }
  return (current as BillingFrequency) || 'monthly'
}
